<template>
  <v-card elevation="2" outlined class="mx-auto" max-width="344">
    <div style="text-align: center">
      <div class="text-h4 mb-1" v-text="scoreCard.quantidade"></div>
      <div class="text-h5 mb-1" v-text="scoreCard.label"></div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    scoreCard: {
      type: Object,
      default: null,
    },
  },
};
</script>
